class SortBy {
    constructor() {
        this.sortBySelects = document.querySelectorAll('[data-sort-by] select');
        this.productCardsWithDiscount = Array.from(document.querySelectorAll('[data-discount-product-card]'));
        this.discounts = [];
        this.pagination = document.querySelector('.pagination__list');
        this.setupDiscounts();
        this.setupOptions();
    }

    async fetchProductsByPage(page = 2) {
        let hasProducts = false;
        const url = new URL(window.location.href);
        url.searchParams.set('page', page);
        const response = await fetch(url.href);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const products = doc.querySelectorAll('#product-grid li');

        if (products.length > 0) {
            products.forEach(product => {
                const hasProduct = this.productCardsWithDiscount.filter(productCard => productCard.querySelector('a').href === product.querySelector('a').href);
                if (!hasProduct.length) {
                    this.productCardsWithDiscount.push(product);
                }
            });
            hasProducts = true;
        }
        
        if (hasProducts) {
            page++;
            await this.fetchProductsByPage(page);
            return;
        }

        this.setupDiscounts();
    }

    setupDiscounts() {
        this.productCardsWithDiscount.forEach(productCard => {
            const discount = parseInt(productCard.getAttribute('data-discount-product-card'));
            if (!this.discounts.find(discount => discount.productCard == productCard)) {
                this.discounts.push({
                    discount: discount,
                    productCard: productCard
                });
            }
        });

        this.discounts.sort((a, b) => {
            return a.discount - b.discount;
        });
        this.discounts.reverse();
    }

    setupOptions() {
        this.sortBySelects.forEach(sortBySelect => {
            sortBySelect.addEventListener('change', () => {
                if (sortBySelect.value === 'highest-discounts') {
                    this.sortByHighestDiscounts();
                }
                if (sortBySelect.value === 'lowest-discounts') {
                    this.sortBySmallestDiscounts();
                }
            });
        });
    }

    async sortByHighestDiscounts() {
        await this.fetchProductsByPage(2);
        const productGrid = document.querySelector('#product-grid');

        this.discounts.forEach(discount => {
            if (!productGrid.contains(discount.productCard)) {
                productGrid.appendChild(discount.productCard);
            }
        });

        if (this.pagination) this.pagination.style.display = 'none';

        const productCount = document.querySelectorAll('.product-count__text span');
        productCount.forEach(count => {
            const countText = count.textContent.split(' ');
            countText[0] = this.discounts.length;
            count.textContent = countText.join(' ');
        });
        
        this.discounts.forEach((discount, index) => {
            discount.productCard.style.order = index;
        });
    }

    async sortBySmallestDiscounts() {
        await this.fetchProductsByPage(2);
        const productGrid = document.querySelector('#product-grid');

        this.discounts.forEach(discount => {
            if (!productGrid.contains(discount.productCard)) {
                productGrid.appendChild(discount.productCard);
            }
        });

        if (this.pagination) this.pagination.style.display = 'none';

        const productCount = document.querySelectorAll('.product-count__text span');
        productCount.forEach(count => {
            const countText = count.textContent.split(' ');
            countText[0] = this.discounts.length;
            count.textContent = countText.join(' ');
        });

        this.discounts.forEach((discount, index) => {
            discount.productCard.style.order = this.discounts.length - index;
        });
    }
}

new SortBy();